import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {}
}

const actions = {
  fetchReport({ commit }, { config, customUrlFnArgs = [] }) {
    const url = '/workers/diary';
    commit('fetchListStart');
    
    return api.client.get(url, config)
      .then(res => {
        commit('fetchListSuccess', res.data);
        return res.data;
      })
      .catch(err => {
        console.log(err)
        commit('fetchListError', err.response.data);
        return Promise.reject(err.response.data);
      })
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'diaryWeeks',
  only: [ 'FETCH_LIST' ],
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn: (id, params) => `/workers/${params.worker_id}/diary${id ? '/'+id : ''}`,
  state,
  actions
});